// extracted by mini-css-extract-plugin
export var createdDate = "_mp-1";
export var divider = "_mp-2";
export var headerDivider = "_mp-3";
export var messagesCard = "_mp-0";
export var messagesContainer = "_mp-6";
export var messagesContainerWrapper = "_mp-4";
export var showLeftPanelButton = "_mp-8";
export var topButtons = "_mp-7";
export var withPadding = "_mp-5";